import Vue from "vue";
import App from "./App.vue";
// 引入路由文件
import router from "./router/index";
// 引入vuex文件
import store from "./store/index";
// 引入axios请求文件
import "./axios";
// 引入Vant ui组件库
import "./assets/base.css";
// rem适配
import "amfe-flexible/index.js";
// 引入按需加载的vant组件
import "./components/components";
import "video.js/dist/video-js.css"; // Video.js 的基础样式
import "vue-video-player/src/custom-theme.css"; // 自定义主题样式

import md5 from 'js-md5';

// import VConsole from "vconsole/dist/vconsole.min.js";
// let vConsole = new VConsole();
// Vue.use(vConsole);
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");